import React from 'react';
import { Dropdown } from 'semantic-ui-react';
import { useIntl } from 'react-intl';
import { connect } from 'react-redux';
import clsx from 'clsx';
import findResult, { removeEmpty } from '@/utils/resultsHelper';
import { readStates, saveStates, states } from '@/constants/lifecycle';
import fetch, { fetchConfig } from '@/hooks/fetch';
import {
  addDatasetNamespace,
  removeDatasetNamespace,
  fetchDatasetNamespaces,
} from '../actions';

const listItems = (namespaces) => removeEmpty(Array.from(new Set(namespaces.map((ns) => ns.name))))
  .sort().map((name) => ({
    key: `dataset_namespace_${name}`,
    text: name,
    value: name,
  }));

const DatasetNamespacesDropdown = ({
  addNamespace,
  category,
  code,
  disabled,
  fetchData,
  loading,
  name,
  namespaces,
  readStatus,
  removeNamespace,
}) => {
  const intl = useIntl();
  fetch.useFetchByCode(fetchData, category, code, readStatus, fetchConfig([category, code]));
  const onDropdownChange = (value) => {
    const added = value.filter((v) => !namespaces.some((item) => item.name.toLowerCase() === v.toLowerCase()));
    const removed = namespaces.filter((item) => !value.includes(item.name));

    added.forEach((namespace) => addNamespace(category, code, name, namespace));
    removed.forEach((namespace) => removeNamespace(category, code, name, namespace));
  };

  return (
    <Dropdown
      allowAdditions
      className={clsx('aridhia-dataset-namespaces-dropdown', 'max-content')}
      disabled={disabled || loading}
      fluid
      loading={loading}
      multiple
      onChange={(e, { value }) => onDropdownChange(value)}
      options={listItems(namespaces)}
      placeholder={intl.formatMessage({ id: 'dataset.suggested.namespaces.placeholder' })}
      search
      selection
      value={namespaces.map((item) => item.name)}
    />
  );
};

const mapStateToProps = ({
  datasetNamespaces: { namespaces },
}, { category, code }) => {
  const item = findResult(namespaces, category, code) || { namespaces: [], ...readStates, ...saveStates };

  return {
    loading: item.readStatus === states.PENDING || item.saveStatus === states.PENDING,
    namespaces: item.namespaces,
    readStatus: item.readStatus,
  };
};

const mapDispatchToProps = {
  addNamespace: addDatasetNamespace,
  removeNamespace: removeDatasetNamespace,
  fetchData: fetchDatasetNamespaces,
};

export default connect(mapStateToProps, mapDispatchToProps)(DatasetNamespacesDropdown);
